import { Query } from '@apollo/client/react/components'
import React from 'react'
import { GET_SITE_IMAGES_QUERY} from '../../queries/GET_SITE_IMAGES_QUERY'
import { getSiteImagesQuery} from '../../schema/schemaTypes'
import { KidsTourView } from './KidsTourView'

export const KidsTourContainer = () => (
  <Query<getSiteImagesQuery> query={GET_SITE_IMAGES_QUERY}>{({ data: data2, loading: loading2, error: error2 }) => {
    if (loading2) { return null }
    if (error2 || !data2 || !data2.getSiteImages) { location.reload() }
    
    const images = data2!.getSiteImages!
    return (
      <KidsTourView images={images} />
    )
  }}</Query>

)



// WEBPACK FOOTER //
// ./src/organisms/KidsTour/KidsTourContainer.tsx